<template>
  <div
    :visible="isAddNewUserActive"
  >
    <div class="card">
      <div class="card-header">
        <h2>TRACKING</h2>
      </div>
      <div class="card-body">
        <div
          class="mapTrakcing"
        >
          <gmap-map
            ref="mapTracking"
            :center="center"
            map-type-id="terrain"
            :zoom="14"
            style="width: 100%; height: 400px"
          >
            <div
              v-show="stateFloating"
              id="floating-time"
              class="floating-time"
            >
              <div class="row">
                <statistic-card-horizontal
                  icon="ClockIcon"
                  :statistic="timeTracking"
                  statistic-title="Tiempo Recorido"
                />
              </div>
            </div>
            <gmap-marker
              v-for="(m, index) in markers"
              :key="index"
              :position="m.position"
              :title="m.title"
              :clickable="true"
              :draggable="false"
              :icon="markerOptions"
            />
            <gmap-marker
              v-for="(m, index) in markerStart"
              :key="index"
              :position="m.position"
              :title="m.title"
              :clickable="true"
              :draggable="false"
              :icon="markerOptionStart"
            />
            <gmap-marker
              v-for="(m, index) in markerCenter"
              :key="`center`+index"
              :position="m.position"
              :title="m.title"
              :clickable="true"
              :draggable="false"
              :icon="markerOptions2"
            />
            <gmap-marker
              v-for="(m, index) in markerEnd"
              :key="`end`+index"
              :position="m.position"
              :title="m.title"
              :clickable="true"
              :draggable="false"
              :icon="markerOptionEnd"
            />
            <gmap-polyline
              :options="{ strokeColor: '#ff0000ff' }"
              :path="paths"
              :editable="false"
              :draggable="false"
            />
          </gmap-map>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div
            class="col-sm-12"
          >
            <div
              style="text-align:end"
            >
              <button
                class="btn btn-primary"
                @click="cerrarTracking()"
              >
                CERRAR
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'
import imgTracking from '../../../assets/images/encuesta/pin-caminando.png'
import imgPinStart from '../../../assets/images/encuesta/pin-start.png'
import imgPinEnd from '../../../assets/images/encuesta/pin-end.png'
import imgTracking2 from '../../../assets/images/encuesta/pin-caminando-2.png'

export default {
  components: {
    StatisticCardHorizontal,
  },
  model: {
    prop: 'isAddNewUserActive',
    event: 'update:is-add-new-user-active',
  },
  props: {
    isAddNewUserActive: {
      type: Boolean,
      required: true,
    },
    dataFicha: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      center: { lat: -6.0319326, lng: -76.9758754 },
      paths: [],
      markers: [],
      markerStart: [],
      markerCenter: [],
      markerEnd: [],
      stateFloating: false,
      lat1: 0,
      lat2: 0,
      timeTracking: '',
      markerOptions: {
        url: imgTracking,
        size: { width: 100, height: 100, f: 'px', b: 'px' },
        scaledSize: { width: 100, height: 100, f: 'px', b: 'px' },
      },
      markerOptions2: {
        url: imgTracking2,
        size: { width: 100, height: 100, f: 'px', b: 'px' },
        scaledSize: { width: 100, height: 100, f: 'px', b: 'px' },
      },
      markerOptionStart: {
        url: imgPinStart,
        size: { width: 100, height: 100, f: 'px', b: 'px' },
        scaledSize: { width: 100, height: 100, f: 'px', b: 'px' },
      },
      markerOptionEnd: {
        url: imgPinEnd,
        size: { width: 100, height: 100, f: 'px', b: 'px' },
        scaledSize: { width: 100, height: 100, f: 'px', b: 'px' },
      },
      icons: [],
      iconPol: [],
      lineSymbol: {
        path: 'M 0,-2 0,1',
        scale: 8,
        strokeColor: '#393',
      },
    }
  },
  emits: ['update:is-busy-tracking', 'update:tracking-show'],
  methods: {
    async dataForm(ficha) {
      this.stateFloating = false
      await this.$refs.mapTracking.$mapPromise.then(mapt => {
        const myControl = document.getElementById('floating-time')
        myControl.index = 1
        mapt.controls[window.google.maps.ControlPosition.TOP_CENTER].setAt(1, myControl)
      })
      this.stateFloating = true
      this.timeTracking = ficha.time
      this.center = { lat: parseFloat(ficha.latitud), lng: parseFloat(ficha.longitud) }
      // LEYENDO TRACKING
      this.iconPol = [
        {
          icon: this.lineSymbol,
          offset: '100%',
        },
      ]
      this.paths = []
      this.markers = []
      this.markerStart = []
      this.markerEnd = []
      this.markerCenter = []
      /* this.paths = [
        { lat: 37.772, lng: -122.214 },
        { lat: 21.291, lng: -157.821 },
        { lat: -18.142, lng: 178.431 },
        { lat: -27.467, lng: 153.027 },
      ] */
      if (ficha.tracking.length > 1) {
        this.lat1 = 0
        this.lat2 = 0
        await ficha.tracking.forEach((item, index) => {
          if (index === 0) {
            this.markerStart.push(
              {
                position: { lat: parseFloat(item.latitud), lng: parseFloat(item.longitud) },
              },
            )
            this.lat1 = parseFloat(item.latitud)
          }
          if (index === 1) {
            this.lat2 = parseFloat(item.latitud)
          }
          if (index === (ficha.tracking.length - 1) / 2) {
            this.markerCenter.push(
              {
                position: { lat: parseFloat(item.latitud), lng: parseFloat(item.longitud) },
              },
            )
          }
          if (index === ficha.tracking.length - 1) {
            this.markerEnd.push(
              {
                position: { lat: parseFloat(item.latitud), lng: parseFloat(item.longitud) },
              },
            )
          }
          this.paths.push({
            lat: parseFloat(item.latitud),
            lng: parseFloat(item.longitud),
          })
        })
        let img = imgTracking
        if (this.lat1 > this.lat2) {
          img = imgTracking2
        }
        this.markerOptions2 = {
          url: img,
          size: { width: 90, height: 90, f: 'px', b: 'px' },
          scaledSize: { width: 90, height: 90, f: 'px', b: 'px' },
        }
      } else {
        await this.markers.push(
          {
            position: { lat: parseFloat(ficha.latitud), lng: parseFloat(ficha.longitud) },
          },
        )
      }
    },
    cerrarTracking() {
      this.$emit('refetch-data', {})
    },
  },
}
</script>
